import { render, staticRenderFns } from "./Coluna2.vue?vue&type=template&id=63209e4c&"
import script from "./Coluna2.vue?vue&type=script&lang=js&"
export * from "./Coluna2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports